import { FsTrack } from "db/model/track/FsTrack";
import { Track } from "model/Track/Track";

export const mapTrack = (fsModel: FsTrack, id: string): Track | undefined => {
  if (!fsModel.name) {
    return undefined;
  }

  return {
    id,
    imageIdOverride: fsModel.imageIdOverride,
    link: fsModel.link,
    mapperName: fsModel.mapperName,
    name: fsModel.name,
  };
};
